import {Tab, Tabs} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'

export interface DevTool {
  /** `/dev/` 뒤에 붙는 경로 */
  path: string
  /** 탭에 쓰는 짧은 이름 */
  label: string
  /** 페이지 상단 제목 */
  title: string
}

/**
 * 운영 도구 목록. 탭과 라우트가 이 배열 하나를 함께 본다.
 * 도구를 추가할 때 여기에만 넣으면 탭에도 같이 올라온다.
 */
export const DEV_TOOLS: DevTool[] = [
  {path: 'signal-config', label: '설치 판정 기준', title: '설치 판정 기준 관리'},
  {path: 'notice-config', label: '공지 팝업', title: '공지 팝업 관리'},
  {path: 'server-cycle-config', label: '통신주기 필터', title: '통신주기 필터 관리'},
  {path: 'photo-config', label: '사진 모달', title: '행 클릭 시 열리는 모달 관리'},
]

const DevToolsNav = () => {
  const navigate = useNavigate()
  const {pathname} = useLocation()

  /* 알 수 없는 경로에서 Tabs 가 경고를 내지 않도록 false 로 떨어뜨린다 */
  const current = DEV_TOOLS.find((tool) => pathname.startsWith(`/dev/${tool.path}`))?.path ?? false

  return (
    <div className={'card mb-5'}>
      <Tabs
        value={current}
        onChange={(_, value) => navigate(`/dev/${value}`)}
        variant={'scrollable'}
        scrollButtons={'auto'}
      >
        {DEV_TOOLS.map((tool) => (
          <Tab
            key={tool.path}
            value={tool.path}
            label={tool.label}
            sx={{fontSize: '1.05rem', fontWeight: 600}}
          />
        ))}
      </Tabs>
    </div>
  )
}

export default DevToolsNav
